// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5897 ? "eeb5c378" : chunkId) + "." + {"632":"4fc8d1292a941940","913":"8f65ae0fc6451de3","3394":"215300e391f7410b","3651":"be7dc805474bf14f","3896":"687a4fd0753abf6a","3957":"36a863bdf4b4c692","5897":"7ce37a7d1cfcee19","6776":"dc5e7825b0212a1c"}[chunkId] + ".js";
};